// authStore.js
import { reactive } from 'vue';
import axios from 'axios';

export const authStore = reactive({
  isLoggedIn: false,
  user: null,
  // 全局唯一登录弹窗状态，废弃组件内局部showLogin
  showLoginModal: false,

  // 新增会员状态
  isVip: false,
  vipTier: 'free',
  
  login(userData) {
    this.isLoggedIn = true;
    this.user = userData;
    // 同步会员信息
    this.isVip = !!userData.is_vip;
    this.vipTier = userData.vip_type || 'free';
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('isLoggedIn', 'true');
    // 持久化会员状态
    localStorage.setItem('isVip', this.isVip);
    localStorage.setItem('vipTier', this.vipTier);
    this.showLoginModal = false;
  },
  
  logout() {
    this.isLoggedIn = false;
    this.user = null;
    // 清空会员
    this.isVip = false;
    this.vipTier = 'free';
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('username');
    localStorage.removeItem('token_expiry');
    localStorage.removeItem('isVip');
    localStorage.removeItem('vipTier');
  },

  // 新增：更新会员信息
  setVipInfo(isVip, tier = 'free') {
    this.isVip = isVip;
    this.vipTier = tier;
    localStorage.setItem('isVip', isVip);
    localStorage.setItem('vipTier', tier);
  },
  
  async refreshToken() {
    const refresh = localStorage.getItem('refresh');
    if (!refresh) {
      this.logout();
      return false;
    }

    try {
      const response = await axios.post('/api/membership/jwt/refresh/', { refresh });
      const { access } = response.data;
      localStorage.setItem('token', access);
      this.isLoggedIn = true;

      const expiryDate = new Date();
      expiryDate.setHours(expiryDate.getHours() + 24);
      localStorage.setItem('token_expiry', expiryDate.toISOString());

      const savedUser = localStorage.getItem('user');
      if (savedUser) this.user = JSON.parse(savedUser);

      // 读取本地会员缓存
      this.isVip = localStorage.getItem('isVip') === 'true';
      this.vipTier = localStorage.getItem('vipTier') || 'free';

      return true;
    } catch (error) {
      console.error('JWT Token Refresh failed:', error);
      this.logout();
      return false;
    }
  },

  // 统一打开登录弹窗
  openLoginModal() {
    this.showLoginModal = true;
  },
  // 统一关闭登录弹窗
  closeLoginModal() {
    this.showLoginModal = false;
  },
  
  async init() {
    const savedStatus = localStorage.getItem('isLoggedIn');
    const hasToken = localStorage.getItem('token');
    const hasRefresh = localStorage.getItem('refresh');

    // 初始化读取会员缓存
    this.isVip = localStorage.getItem('isVip') === 'true';
    this.vipTier = localStorage.getItem('vipTier') || 'free';

    if (savedStatus === 'true' && hasToken) {
      const savedUser = localStorage.getItem('user');
      try {
        if (savedUser) this.user = JSON.parse(savedUser);
        this.isLoggedIn = true;
      } catch (e) {
        this.logout();
      }
    } else if (hasRefresh) {
      await this.refreshToken();
    }
  }
});